import { render } from "./ReactivationDepositStep.vue?vue&type=template&id=057461e2&scoped=true"
import script from "./ReactivationDepositStep.vue?vue&type=script&lang=js"
export * from "./ReactivationDepositStep.vue?vue&type=script&lang=js"

import "./ReactivationDepositStep.vue?vue&type=style&index=0&id=057461e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057461e2"]])

export default __exports__